<template>
  <v-text-field
      rounded="lg"
      :error-messages="error"
      :label="translation(translationList.street_number, 'Număr stradă')"
      v-model="streetNumber"
      :rules="streetNumberValidationRules"
      name="street_number"
      bg-color="surface"
      variant="outlined"
      :tile="true"
  >
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, toRefs } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
    addressIndex: Number as () => number | null,
  },
  setup(props, { emit }) {
    const { modelValue, addressIndex } = toRefs(props);
    const streetNumber = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      streetNumber.value = newValue;
    });

    watch(streetNumber, (newValue) => {
      const isValid = validateStreetNumber(newValue);
      if (isValid) {
        emit('update:modelValue', newValue);
      } else {
        emit('update:modelValue', null);
      }
      emit('validation-address-status', { field: Number.isInteger(addressIndex.value) ? `street_number-${addressIndex.value}` : 'street_number', isValid });
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const streetNumberValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: string) => /^[A-Za-z0-9\s]+$/.test(v) || translation(translationList.value.invalid_street_number_chars, 'Caractere invalide în câmpul număr stradă.'),
    ];

    function validateStreetNumber(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = streetNumberValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return streetNumberValidationRules.every(rule => rule(value) === true);
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateStreetNumber(streetNumber.value);
      emit('validation-address-status', { field: Number.isInteger(addressIndex.value) ? `street_number-${addressIndex.value}` : 'street_number', isValid });

      // Listen for validate events
      window.addEventListener('validate-address', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
      window.addEventListener('validate-house', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && data.detail === (Number.isInteger(addressIndex.value) ? `street_number-${addressIndex.value}` : 'street_number')) {
        const isValid = validateStreetNumber(streetNumber.value, true);
        if (isValid) {
          emit('validation-address-status', { field: Number.isInteger(addressIndex.value) ? `street_number-${addressIndex.value}` : 'street_number', isValid });
        }
      }
    };

    return {
      streetNumber,
      streetNumberValidationRules,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>